import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

/**
 * Premium industrial-standard termination dialog for participants.
 * Features a clean UI, professional typography, and window closure logic.
 */
export const MeetingEndDialog = ({ visible, onHide }) => {
  const handleCloseWindow = () => {
    window.close();
    // setTimeout(() => {
    //   window.location.href = "/";
    // }, 500);
  };

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      closable={false}
      draggable={false}
      resizable={false}
      showHeader={false}
      maskClassName="backdrop-blur-md bg-black/40" // Darker, blurrier backdrop
      contentClassName="p-0 rounded-xl shadow-2xl border-none" // Remove default padding, larger rounding
      style={{ width: "90vw", maxWidth: "480px" }}
    >
      <div className="flex flex-col items-center justify-center p-12 bg-white rounded-2xl relative overflow-hidden">
        {/* Decorative background element */}
        <div className="absolute top-0 w-full h-2 "></div>

        <div className="mb-6 bg-emerald-50 p-4 rounded-full ring-8 ring-emerald-50/50">
          <i
            className="pi pi-check text-emerald-500"
            style={{ fontSize: "2.5rem", fontWeight: "bold" }}
          ></i>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-2 tracking-tight">
          Meeting Ended Successfully
        </h2>

        <p className="text-center text-gray-500 mb-8 leading-relaxed text-sm font-medium">
          <span className="text-gray-700">Thank you for joining.</span>
        </p>

        <Button
          label="Close Window"
          onClick={handleCloseWindow}
          className="w-full p-button-danger p-button-raised rounded-xl py-3.5 font-semibold text-white shadow-lg shadow-red-200 hover:shadow-red-300 transition-all transform hover:-translate-y-0.5 active:translate-y-0"
          style={{ backgroundColor: "#ef4444", borderColor: "#ef4444" }} // Explicit Tailwind red-500
        />
      </div>
    </Dialog>
  );
};
